<template>
    <div>
        <div class="row boxHead">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h2>{{labels[labelOptions[type]]}}</h2>
                <br class="hidden-xs" />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import useCMS from '../../shared/composables/useCMS';
export default {
    name: 'orderInfoHeader',
    setup: function () {
        const { labels } = useCMS();
        const labelOptions = {
            'common': 1188,
            'other': 1189,
            'replace': 1190,
            'service': 1191
        }

        return {
            labels,
            labelOptions
        }
    },
    props: {
        type: String,
    }
}
</script>
